import React, {forwardRef} from 'react';
import './Feedback.sass';
import renderHTML from 'react-render-html';
import Button from "../../../ui/Button/Button";
const Feedback = forwardRef(({ answers, feedback, choices, toggle },ref) => {
  return (
    <div ref={ref} className={answers ? 'feedback' : 'hidden'}>
      {feedback ? <h2 className="title">{feedback.title}</h2> : ''}
      <hr />
      {feedback ? <p className="body">{feedback.body}</p> : ''}
      <ul>
        {choices
          ? choices.map((choice, index) => {
              const { correct } = choice;
              let selected = answers[`question_${index + 1}`] ? answers[`question_${index + 1}`] : false;
              let fb = (correct&&selected)?choice.feedback:(choice.altFeedback?choice.altFeedback:choice.feedback)
              return (
                <li key={index} className={choice.color?'border-'+choice.color:(Boolean(selected) === correct ? 'border-green' : 'border-red')}>
                  {renderHTML(fb)}
                </li>
              );
            })
          : ''}
      </ul>
        <Button data={"Review Video"} callback={toggle} style={{
            position:"absolute",
            bottom:-20,
            scale:.25
        }}/>
    </div>
  );
});

export default Feedback;
